import React from "react";
import "./drugCard.css";

const DrugCard = props => {
  return (
    <div className="mainCard">
      <div className="leftDiv">
        <h5>{props.DrugName}</h5>
        <p>Drug Class: {props.DrugClass}</p>
        <p className="prohibition">Prohibited {props.Status}</p>
      </div>
      <div className="rightDiv">
        <h1>{props.WadaClass}</h1>
        <p>WADA Class</p>
      </div>
    </div>
  );
};

export default DrugCard;
